import { Commit } from "vuex";

export default function makeTypeSafeCommitter<State, Mutations>(
  mutations: Mutations,
  prefix = ""
) {
  type OmitFirstArg<F> = F extends (x: State, ...args: infer P) => infer R
    ? (...args: P) => R
    : never;

  function _makeTypeSafeCommitter(): {
    [Property in keyof Mutations]: (
      commit: Commit,
      ...args: Parameters<OmitFirstArg<Mutations[Property]>>
    ) => void;
  } {
    type KeyType = keyof Mutations;
    type TypeSafeMutations = {
      [Property in KeyType]: (
        commit: Commit,
        ...args: Parameters<OmitFirstArg<Mutations[Property]>>
      ) => void;
    };

    const result = {} as Record<KeyType, unknown>;
    (Object.keys(mutations) as KeyType[]).forEach((key: KeyType) => {
      result[key] = (commitFn: Commit, ...args: unknown[]) => {
        commitFn(`${prefix}${key}`, ...args);
      };
    });
    return result as TypeSafeMutations;
  }

  return _makeTypeSafeCommitter();
}
